export default [
  {
    path: '/dashboard/ecommerce',
    name: 'dashboard-ecommerce',
    component: () => import('@/views/dashboard/ecommerce/Ecommerce.vue'),
  },
  {
    path: '/dashboard/ecommerce/analytics',
    name: 'dashboard-ecommerce-analytics',
    component: () => import('@/views/dashboard/ecommerce/AnalyticsIndex.vue'),
  },
  {
    path: '/dashboard/ecommerce/smartReport',
    name: 'dashboard-ecommerce-smartReport',
    component: () => import('@/views/dashboard/ecommerce/smartReport.vue'),
  },
]
